import { DefaultEffects, } from "@fluentui/react";
// eslint-disable-next-line prefer-const
export let typeAheadCalloutStyle = {
    root: {
        boxShadow: DefaultEffects.elevation4,
        borderRadius: 2,
        marginTop: 0,
        boxSizing: "border-box",
        width: "500px",
        minWidth: 0,
        maxWidth: "calc(100vw - 32px)",
        overflow: "auto",
        top: "0px!important",
        left: "0px!important",
        selectors: {
            "@media(max-width: 600px)": {
                top: "0px",
                left: "0px!important",
                width: "100%",
                minWidth: 0,
                maxWidth: "100%",
            },
        },
        "& .noResultsDiv": {
            height: "250px",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            display: "flex",
            marginLeft: "20%",
            color: "#605E5C",
        },
        "& .advancedSearchLbl": {
            float: "right",
            paddingRight: "10px",
            paddingTop: "5px",
        },
    },
    container: {
        zIndex: 3,
        position: "relative",
    },
    calloutMain: {
        width: "100%",
        minWidth: 0,
        maxWidth: "100%",
        minHeight: "fit-content",
        maxHeight: "250px!important",
        height: "250px",
    },
};
export const ProgressIndicatorStyle = {
    itemProgress: {
        paddingBottom: "4px",
    },
};
export const defaultSuggestionItem = {
    width: "100%",
    float: "left",
    padding: "5px",
};
